import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import burger from '../../../assets/menu/hamburger-button.png';

import categoryClosed from '../../../assets/menu/category-closed.svg';
import categoryOpen from '../../../assets/menu/category-open.svg';

import bullet from '../../../assets/menu/bullet.svg';
import bulletOff from '../../../assets/menu/bulletOff.svg';

import categorySalesOff from '../../../assets/menu/sales-off.svg';
import categorySales from '../../../assets/menu/sales-on.svg';

import categoryPartnershipOff from '../../../assets/menu/partnership-off.svg';
import categoryPartnership from '../../../assets/menu/partnership-on.svg';

import categorySettingsOff from '../../../assets/menu/setting-off.svg';
import categorySettings from '../../../assets/menu/setting-on.svg';

import homeIconOff from '../../../assets/menu/home-off.svg';
import homeIconOn from '../../../assets/menu/home-on.svg';

import integrationsIconOff from '../../../assets/menu/integrations-off.svg';
import integrationsIconOn from '../../../assets/menu/integrations-on.svg';

import logo from '../../../assets/mvp-logo-white.svg';
import * as userActions from "../../../redux/User/actions";
import { ext } from "../../../utils/general.js";
import * as ROUTES from "../../../utils/routes";

import constants from "../../../utils/constants.js";
import { isAdmin } from "../../../utils/user.js";

import './menu.scss';

const SIZEBAR_WIDTH = '275px';

const Menu = props => {
	const [openCategory, setOpenCategory] = useState(null);
	const [selectedRoute, setSelectedRoute] = useState(null);
	const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const menuOpen = useSelector(state => state.user.menuOpen);
	const isAdminUser = isAdmin();

	useEffect(() => {
		setSelectedRoute(location.pathname);
	}, [location.pathname]);

	useEffect(() => {
		const load = async () => {
			let menuData = await localStorage.getItem(constants.MENU_DATA);
			menuData = JSON.parse(menuData);
			if(menuData) {
				setOpenCategory(menuData.openCategory);
			}
		};
		load();
	}, []);

	const toggleCategory = (key, route) => {
		setOpenCategory(key);
		doNavigate(key, route);
	};

	const doNavigate = (openCategory, route) => {
		localStorage.setItem(constants.MENU_DATA, JSON.stringify({openCategory, route}));
		navigate(route);
	};

	const renderMenuCategory = (key, label, route, iconOn, iconOff, items) => {
		const selected = selectedRoute === route;
		const isOpen = openCategory === key;

		return (
			<div key={key}>
				<div className={selected ? 'menu-category' : 'menu-category-off'} onClick={() => toggleCategory(key, route)}>
					<div className="menu-item-icon"><img src={selected ? iconOn : iconOff} alt="" /></div>
					<div style={{width: '100%'}}>{label}</div>
					<img src={isOpen ? categoryOpen : categoryClosed} alt="" />
				</div>
				<div style={{display: isOpen ? '' : 'none'}}>
					{ items.map(item => renderMenuItem(item.key, item.label, item.route, bullet, bullet, true )) }
				</div>
			</div>
		)
	};

	const renderMenuItem = (key, label, action, iconOn, iconOff, inCategory) => {
		const selected = selectedRoute === action;

		if(inCategory) {
			iconOn = bullet;
			iconOff = bulletOff;
		}

		if(typeof action === 'string') {
			return (
				<div key={key} className={selected ? 'menu-item' : 'menu-item-off'} onClick={() => doNavigate(openCategory,action)}>
					<div className="menu-item-icon"><img style={{padding: inCategory ? '0px 5px' : '0'}} src={selected ? iconOn : iconOff} alt="" /></div>
					<div>{label}</div>
				</div>
			)
		}
		else if(typeof action === 'function') {
			return (
				<div key={key} className={selected ? 'menu-item' : 'menu-item-off'} onClick={action}>
					<div className="menu-item-icon"><img src={selected ? iconOn : iconOff} alt="" /></div>
					<div>{label}</div>
				</div>
			)
		}

		return (
			<div key={key} className={selected ? 'menu-item' : 'menu-item-off'}>
				<div className="menu-item-icon">{ selected && <img src={bullet} alt="" /> }</div>
				<div>{label}</div>
			</div>
		)
	};

	const toggle = () => {
		dispatch(userActions.toggleMenu());
	};

	const salesItems = [
		{ key: 'opportunities', label: 'Opportunities', route: ROUTES.OPPORTUNITIES},
		{ key: 'co-sell-opportunities', label: 'Co-Sell Opportunities', route: ROUTES.CO_SELL_OPPORTUNITIES},
		{ key: 'heatmaps', label: 'Heatmaps', route: ROUTES.HEATMAPS},
		{ key: 'campaigns', label: 'Campaigns', route: ROUTES.CAMPAIGNS}
	];

	const dataItems = [
		{ key: 'mapping', label: 'Account Mapping', route: ROUTES.MAPPING},
		{ key: 'accounts', label: 'Accounts', route: ROUTES.ACCOUNTS},
		{ key: 'contacts', label: 'Contacts', route: ROUTES.CONTACTS}
	];

	const partnershipItems = [
		{ key: 'programs', label: 'Programs', route: ROUTES.PROGRAMS},
		{ key: 'funds', label: 'Funds', route: ROUTES.FUNDS},
		{ key: 'marketing', label: 'Marketing', route: ROUTES.MARKETINGS}
	];

	const adminItems = [
		{ key: 'users', label: 'User Management', route: ROUTES.USERS},
		{ key: 'license', label: 'License Management', route: ROUTES.LICENSE},
		{ key: 'db_management', label: 'Database Management', route: ROUTES.DBSNAPSHOTS},
		{ key: 'salesforce_managers', label: 'Salesforce Managers', route: ROUTES.SALESFORCE_MANAGERS},
	];

	return (
		<div className="menu-wrapper" style={{ width: menuOpen ? SIZEBAR_WIDTH : '0px' }}>
			<div onClick={toggle} className="menu-trigger">
				<img src={burger} style={{cursor: 'pointer', padding: '0 25px'}} alt="" />
				{
					menuOpen &&
					<img src={logo} alt="Version 1.22.0" title="Version 1.22.0" className="logo" style={{width: '70px'}}/>
				}
			</div>

			{ renderMenuItem('home', 'Home', ROUTES.HOME, homeIconOn, homeIconOff ) }

			{ renderMenuCategory('sales', 'Sales', ROUTES.SALES, categorySales, categorySalesOff, salesItems) }

			{ !ext(user) && renderMenuCategory('data', 'Data', ROUTES.DATA, categorySales, categorySalesOff, dataItems) }

			{ renderMenuCategory('partnership', 'Partnership', ROUTES.PARTNERSHIP, categoryPartnership, categoryPartnershipOff, partnershipItems) }


			{ renderMenuItem('bi', 'BI', ROUTES.BI, categorySales, categorySalesOff ) }

			{ isAdminUser && renderMenuItem('integrations', 'Integrations', ROUTES.INTEGRATIONS, integrationsIconOn, integrationsIconOff ) }

			{ isAdminUser && renderMenuCategory('settings', 'Settings', ROUTES.SETTINGS, categorySettings, categorySettingsOff, adminItems) }

			<div style={{height: '100%', color: 'grey', display: 'flex', padding: '40px', alignItems: 'flex-end', fontSize: '12px'}}>
				Version 1.22.0
			</div>
		</div>
	)
};

export default Menu;
